import { render, staticRenderFns } from "./LayoutLoose.vue?vue&type=template&id=7f1c785b&"
import script from "./LayoutLoose.vue?vue&type=script&lang=js&"
export * from "./LayoutLoose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports